import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import CloseIcon from "@mui/icons-material/Close";
import s from "./Tab.module.scss";
import { Textfit } from "react-textfit";

const Tab = ({
  tabbarWidth,
  tabs,
  changeTab,
  removeTab,
  isCollapse,
  setOpenDialog,
}) => {
  // const tabbar = document.getElementById("tabbar");
  // if (tabbar) {
  //   tabbar.addEventListener("wheel", (event) => {
  //     event.preventDefault();

  //     tabbar.scrollBy({
  //       left: event.deltaX < 0 ? -89 : 89,
  //     });
  //   });
  // }
  const [position, setPosition] = useState(0);
  const [isTheLeft, setIsTheLeft] = useState(false);
  const [isTheRight, setIsTheRight] = useState(false);
  const [tabsNumber, setTabsNumber] = useState(0);
  const tabbarRef = useRef();
  const tabWidthWithBorder = 160;

  useEffect(() => {
    if (position <= 0) {
      setIsTheLeft(true);
    } else {
      setIsTheLeft(false);
    }

    if (position + (tabbarWidth - 80) >= tabbarRef.current.scrollWidth) {
      setIsTheRight(true);
    } else {
      setIsTheRight(false);
    }
  }, [position, tabbarWidth]);

  // Handle position changing after clicking collapse sidebar
  useEffect(() => {
    if (isCollapse) {
      if (tabs.storedTabs.length * tabWidthWithBorder >= tabbarWidth) {
        setPosition((position) => (position - 256 < 0 ? 0 : position - 256));
      } else {
        setPosition(0);
      }
    }
  }, [isCollapse]);

  useEffect(() => {
    const { clientWidth, scrollWidth } = tabbarRef.current;
    const rightmost = scrollWidth - clientWidth;
    const indexNumber = tabs.storedTabs.findIndex((tab) => {
      return tab.tabId === tabs.currentTab;
    });

    // clicked the lestmost tab
    if (indexNumber === 0) {
      tabbarRef.current.scrollTo(0, 0);
      setPosition(0);
      return;
    }

    // clicked the rightmost tab
    if (indexNumber === tabs.storedTabs.length - 1) {
      tabbarRef.current.scrollTo(rightmost, 0);
      setPosition(rightmost);
      return;
    }

    const displayRange = getAllDisplayingTabIndexRange();
    const { firstTabIndex, lastTabIndex } = displayRange;
    const newPosition = indexNumber * tabWidthWithBorder;

    if (indexNumber >= firstTabIndex && indexNumber <= lastTabIndex) {
      const displayRange = getOnlyFullyDisplayTabIndexRange();
      const { firstTabIndex, lastTabIndex, distanceOfMovement } = displayRange;
      if (indexNumber < firstTabIndex) {
        tabbarRef.current.scrollTo(position - distanceOfMovement, 0);
        setPosition((position) => position - distanceOfMovement);
      }
      if (indexNumber > lastTabIndex) {
        tabbarRef.current.scrollTo(position + distanceOfMovement, 0);
        setPosition((position) => position + distanceOfMovement);
      }
    } else if (indexNumber < firstTabIndex && indexNumber >= 0) {
      tabbarRef.current.scrollTo(newPosition, 0);
      setPosition(newPosition);
    } else {
      tabbarRef.current.scrollTo(
        newPosition + tabWidthWithBorder - clientWidth,
        0,
      );
      setPosition(newPosition + tabWidthWithBorder - clientWidth);
    }
  }, [tabs.currentTab]);

  // handle new tab opening by clicking the page in sidebar
  useEffect(() => {
    const { clientWidth, scrollWidth } = tabbarRef.current;
    if (tabs.storedTabs.length > tabsNumber) {
      const rightmost = scrollWidth - clientWidth;
      tabbarRef.current.scrollTo(rightmost, 0);
      setPosition(rightmost);
    }
    setTabsNumber(tabs.storedTabs.length);
  }, [tabs.storedTabs]);

  const getAllDisplayingTabIndexRange = () => {
    let firstTabIndex;
    let lastTabIndex;
    const maxDisplayTab = Math.floor(calcNumberOfMaxDisplayTab());
    const distanceOfMovement = calcDistanceOfMovement();
    if (position % tabWidthWithBorder === 0) {
      if ((tabbarWidth - 80) % tabWidthWithBorder === 0) {
        firstTabIndex = position / tabWidthWithBorder;
        lastTabIndex = firstTabIndex + maxDisplayTab - 1;
      } else {
        firstTabIndex = position / tabWidthWithBorder;
        lastTabIndex = firstTabIndex + maxDisplayTab;
      }
    } else {
      const firstTabPosition = position - distanceOfMovement;
      firstTabIndex = firstTabPosition / tabWidthWithBorder;
      lastTabIndex = firstTabIndex + maxDisplayTab;
    }
    return { firstTabIndex, lastTabIndex };
  };

  const getOnlyFullyDisplayTabIndexRange = () => {
    let firstTabIndex;
    let lastTabIndex;
    const maxDisplayTab = Math.floor(calcNumberOfMaxDisplayTab());
    const distanceOfMovement = calcDistanceOfMovement();
    if (position % tabWidthWithBorder === 0) {
      firstTabIndex = position / tabWidthWithBorder;
      lastTabIndex = firstTabIndex + maxDisplayTab - 1;
    } else {
      const firstTabPosition =
        position + (tabWidthWithBorder - distanceOfMovement);
      firstTabIndex = firstTabPosition / tabWidthWithBorder;
      lastTabIndex = firstTabIndex + maxDisplayTab - 1;
    }
    return { firstTabIndex, lastTabIndex, distanceOfMovement };
  };

  const calcNumberOfMaxDisplayTab = () => {
    if (tabs.storedTabs.length * tabWidthWithBorder >= tabbarWidth) {
      const maxDisplayTab = (tabbarWidth - 80) / tabWidthWithBorder;
      return maxDisplayTab;
    } else {
      return tabs.storedTabs.length;
    }
  };

  const calcDistanceOfMovement = () => {
    let distanceOfMovement =
      tabbarWidth -
      80 -
      Math.floor(calcNumberOfMaxDisplayTab()) * tabWidthWithBorder;
    if (distanceOfMovement < 0) {
      distanceOfMovement = -distanceOfMovement;
    }
    return tabWidthWithBorder - distanceOfMovement;
  };

  const handleChangeTab = (obj, index) => {
    const { clientWidth } = tabbarRef.current;

    if (
      index === 0 ||
      index === tabs.storedTabs.length - 1 ||
      clientWidth % tabWidthWithBorder === 0
    ) {
      return changeTab(obj);
    }

    const displayRange = getOnlyFullyDisplayTabIndexRange();
    const { firstTabIndex, lastTabIndex, distanceOfMovement } = displayRange;
    if (index < firstTabIndex) {
      tabbarRef.current.scrollTo(position - distanceOfMovement, 0);
      setPosition((position) => position - distanceOfMovement);
    }
    if (index > lastTabIndex) {
      tabbarRef.current.scrollTo(position + distanceOfMovement, 0);
      setPosition((position) => position + distanceOfMovement);
    }
    return changeTab(obj);
  };

  const handleCloseTab = (event, routeObj) => {
    event.preventDefault();
    event.stopPropagation();
    removeTab(routeObj);
  };

  const handleScrollLeft = () => {
    tabbarRef.current.scrollTo(position - tabWidthWithBorder, 0);
    setPosition((position) =>
      position - tabWidthWithBorder < 0 ? 0 : position - tabWidthWithBorder,
    );
  };

  const handleScrollRight = () => {
    const { clientWidth, scrollWidth } = tabbarRef.current;
    tabbarRef.current.scrollTo(position + tabWidthWithBorder, 0);
    const rightmost = scrollWidth - clientWidth;
    setPosition((position) =>
      position + tabWidthWithBorder > rightmost
        ? rightmost
        : position + tabWidthWithBorder,
    );
  };

  const arrowBtnStyle = {
    color: "#222",
    width: "40px",
  };

  const disabledArrowBtnStyle = {
    color: "#ccc",
    width: "40px",
  };

  const isLeftRightButtonAppeared = () => {
    return tabs?.storedTabs?.length * tabWidthWithBorder >= tabbarWidth;
  };

  return (
    <div className={s.tabsContainer}>
      {isLeftRightButtonAppeared() && (
        <button
          className={s.scrollLeftBtn}
          onClick={handleScrollLeft}
          disabled={isTheLeft}
        >
          <KeyboardArrowLeftIcon
            sx={isTheLeft ? disabledArrowBtnStyle : arrowBtnStyle}
          />
        </button>
      )}
      <div ref={tabbarRef} id="tabbar" className={s.tabs}>
        {tabs.storedTabs.map((obj, index) => {
          return (
            <div
              key={obj.tabId}
              id={obj.tabId}
              className={[
                s.tab,
                tabs.currentTab === obj.tabId ? s.currentTab : "",
              ].join(" ")}
              onClick={() => {
                return handleChangeTab(obj, index);
              }}
            >
              <Textfit
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                max="12"
                autoResize={false}
              >
                {obj.name}
              </Textfit>
              <button
                key={obj.tabId}
                className={[
                  s.closeBtn,
                  tabs.currentTab === obj.tabId ? s.activeCloseBtn : "",
                ].join(" ")}
                onClick={(event) => {
                  return handleCloseTab(event, obj);
                }}
              >
                <CloseIcon sx={{ fontSize: "14px", marginTop: "3px" }} />
              </button>
            </div>
          );
        })}
      </div>
      {tabs?.storedTabs?.length >= 5 && (
        <div className={`${s.closeAllTabBtnContainer}`}>
          <button
            className={s.closeAllTabBtn}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpenDialog(true);
            }}
          >
            <CloseIcon sx={{ fontSize: "14px" }} />
          </button>
        </div>
      )}
      {isLeftRightButtonAppeared() && (
        <button
          className={s.scrollRightBtn}
          onClick={handleScrollRight}
          disabled={isTheRight}
        >
          <KeyboardArrowRightIcon
            sx={isTheRight ? disabledArrowBtnStyle : arrowBtnStyle}
          />
        </button>
      )}
    </div>
  );
};

export default React.memo(Tab);
